// ==========================
// src/components/Footer.jsx
// ==========================
import React from 'react';
import { Box, Container, Typography, Stack, IconButton, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import MusicNoteIcon from '@mui/icons-material/MusicNote'; // placeholder para TikTok
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function Footer(){
  const socials = [
    { label: 'Instagram', href: 'https://www.instagram.com/angeloroecuador?igsh=Mnl3MjV6NHhrZWJj', icon: <InstagramIcon /> },
    { label: 'Facebook', href: 'https://www.facebook.com/share/1QosNtn2gn/', icon: <FacebookIcon /> },
    { label: 'TikTok', href: 'https://www.tiktok.com/@angelde_oro?_t=ZM-8yu21jEvMve&_r=1', icon: <MusicNoteIcon /> }, // reemplaza por un SVG oficial si lo deseas
  ];

  const waHref = 'https://wa.me/593983633594';

  const openCookieSettings = (e) => {
    e.preventDefault();
    window.dispatchEvent(new Event('cookie:open-settings'));
  };

  return (
    <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', py: 5, mt: 6 }}>
      <Container sx={{ textAlign:'center', display:'grid', gap: 1.5 }}>
        <Typography variant="body1" sx={{ fontWeight:700 }}>Ángel de Oro</Typography>

        {/* Iconos sociales */}
        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
          {socials.map(s => (
            <IconButton
              key={s.label}
              component="a"
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              sx={{
                color:'primary.contrastText',
                border:'1px solid rgba(255,255,255,0.7)',
                '&:hover': { background:'rgba(255,255,255,0.12)' }
              }}
            >
              {s.icon}
            </IconButton>
          ))}
        </Stack>

        {/* WhatsApp */}
        <Stack direction="row" spacing={0.75} justifyContent="center" alignItems="center">
          <WhatsAppIcon fontSize="small" />
          <Typography variant="body2">
            WhatsApp:&nbsp;
            <Link href={waHref} target="_blank" rel="noopener noreferrer" underline="always" color="inherit">
              +593 98 363 3594
            </Link>
          </Typography>
        </Stack>

        {/* Enlaces legales */}
        <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" sx={{ mt: 1 }}>
          <Link href="#privacidad" underline="hover" color="inherit">Privacidad y cookies</Link>
          <Link href="#" underline="hover" color="inherit" onClick={openCookieSettings}>Configuración de cookies</Link>
        </Stack>

        <Typography variant="body2" sx={{ opacity: 0.9 }}>© {new Date().getFullYear()} — Todos los derechos reservados</Typography>
      </Container>
    </Box>
  );
}